export enum CovidTemplateType {
  COVID_PRIVACY_INFORMATIVE = 'COVID_PRIVACY_INFORMATIVE',
  EMPLOYERS_AND_EXTERNAL_ENTRANCE_PROCEDURE = 'EMPLOYERS_AND_EXTERNAL_ENTRANCE_PROCEDURE',
  TEMPERATURE_CHECK_APPOINTMENT = 'TEMPERATURE_CHECK_APPOINTMENT',
  PERSONAL_DATA_TREATMENT_COVID_REGISTRY = 'PERSONAL_DATA_TREATMENT_COVID_REGISTRY',
  GENERAL_WORKPLACE_COVID_PROTOCOL = 'GENERAL_WORKPLACE_COVID_PROTOCOL',
  COVID_PROTOCOL_IMPLEMENTATION = 'COVID_PROTOCOL_IMPLEMENTATION'
}
